// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".a04d3d9489b14d8fe6f7822395bb0601.js";
};